import {Component, Input, ViewChild} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {ScheduledUserReport} from './scheduled-user-report.model';
import {ReportBuilderService} from '../../report-builder.service';
import {DatePipe} from '@angular/common';
import {ConfirmDialogComponent} from '../../../../shared/components/dialogs/confirm-dialog.component';
import {GlobalSpinnerService} from '../../../../shared/components/loader-service/global-spinner.service';
import {SnackBarService} from '../../../../shared/services/snackbar.service';
import {DeliveryFrequencyLabelsKL} from '../../../../shared/domain/delivery-frequency.enum';

@Component({
  selector: 'cm-report-builder-scheduled-reports',
  templateUrl: './report-builder-scheduled-reports.component.html',
  styleUrls: ['./report-builder-scheduled-reports.component.scss']
})
export class ReportBuilderScheduledReportsComponent {
  @Input() paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  showReportRunner = false;

  dataSource = new MatTableDataSource<ScheduledUserReport>();

  DeliveryFrequencyLabelsKL = DeliveryFrequencyLabelsKL();
  columns = [
    {key: 'name', header: 'Name', cell: (row: ScheduledUserReport) => `${row.report.name}`},
    {
      key: 'createdOn',
      header: 'Date created',
      rawHtml: true,
      cell: (row: ScheduledUserReport) => `   <div class="">
        ${this.datePipe.transform(row.createdOn, 'yyyy-MM-dd')}  
      <small class="d-block">${this.datePipe.transform(row.createdOn, 'hh:mm a')}</small>
      </div>`
    },
  ];
  visibleColumns;
  loading = false;

  constructor(private service: ReportBuilderService,
              private matDialog: MatDialog,
              private sbs: SnackBarService,
              private spinner: GlobalSpinnerService,
              private datePipe: DatePipe) {
    this.visibleColumns = this.columns.map(c => c.key);
    this.visibleColumns.push('recipients');
    this.visibleColumns.push('deliveryFrequency');
    this.visibleColumns.push('options')
  }

  ngOnInit(): void {
    this.refreshData();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  refreshData() {
    this.loading = true;
    this.service.scheduledUserConfigsGet().subscribe(next => {
      this.dataSource.data = next;
      this.loading = false;
    }, () => {
      this.loading = false;
    })
  }

  updateReport(el: ScheduledUserReport) {
    if (!Array.isArray(el.recipients)) {
      el.recipients = ['' + el.recipients];
    }
    this.loading = true;
    this.service.scheduledUserConfigsPut(el).subscribe(next => {
      this.loading = false;
      this.refreshData();
      this.sbs.success('Scheduled report configuration updated successfully');
    }, () => {
      this.loading = false;
      this.refreshData();
      this.sbs.success('Error updating configuration - please check all fields');
    });
  }

  deleteReport(el) {
    this.matDialog.open(ConfirmDialogComponent, <MatDialogConfig>{
      data: {
        subtitle: 'Are you sure you want to delete this scheduled report?'
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.spinner.showLoader();
        this.service.scheduledUserConfigsDelete(el).subscribe(next => {
            this.sbs.success('Scheduled report configuration deleted successfully');
            this.spinner.hideLoader();
            this.refreshData();
          },
          () => {
            this.spinner.hideLoader();
          });
      }
    })
  }
}
